import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router, ActivatedRoute, UrlSegment } from '@angular/router';
import dayjs from "dayjs";
import { catchError, throwError } from 'rxjs';
import { ExstraDetailModel } from 'src/app/models/season-models/exstra-detail-model';
import { SeasonCropModel } from 'src/app/models/season-models/season-crop-model';
import { SeasonFarmsModel } from 'src/app/models/season-models/season-farms-model';
import { SeasonFertilizerPlacementModel } from 'src/app/models/season-models/season-fertilizer-placement';
import { SeasonFertilizerPlacementWithPlantingModel } from 'src/app/models/season-models/season-fertilizer-placement-with-planting-model';
import { SeasonFertilizerTypeModel } from 'src/app/models/season-models/season-fertilizer-type-model';
import { SeasonFieldPlantModel } from 'src/app/models/season-models/season-field-plant-model';
import { SeasonFieldPlantSpreadModel } from 'src/app/models/season-models/season-field-plant-spread-model';
import { SeasonTypeModel } from 'src/app/models/season-models/season-field-type-model';
import { SeasonFieldsModel } from 'src/app/models/season-models/season-fields-model';
import { SeasonHarvestResiduesModel } from 'src/app/models/season-models/season-harvest-residues-model';
import { SeasonIrrigationTypeModel } from 'src/app/models/season-models/season-irrigation-type-model';
import { SeasonMetaDataCombinedModel } from 'src/app/models/season-models/season-meta-data-combined-model';
import { SeasonMethodOfTopDressingModel } from 'src/app/models/season-models/season-method-of-top-dressing-model';
import { SeasonPlantActionModel } from 'src/app/models/season-models/season-plant-action-model';
import { SeasonPlantFertilizerTypeModel } from 'src/app/models/season-models/season-plant-fertilizer-type-model';
import { SeasonPodEffectivenessModel } from 'src/app/models/season-models/season-pod-effectiveness-model';
import { SeasonTillageModel } from 'src/app/models/season-models/season-tillage-model';
import { SeasonTopDressingMethodModel } from 'src/app/models/season-models/season-top-dressing-method-model';
import { SeasonTypeOfFertilizerBobModel } from 'src/app/models/season-models/season-type-of-fertilizer-bob-model';
import { SeasonTypeOfTopDressingFertilizer } from 'src/app/models/season-models/season-type-of-top-dressing-fertilizer-model';
import { SeasonWaterQualityEcModel } from 'src/app/models/season-models/season-water-quality-ec-model';
import { SeasonsStatusModel } from 'src/app/models/season-models/seasons-status-model';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { SeasonManagerService } from 'src/app/services/season-manager.service';
import { SeasonSharedDataService } from 'src/app/services/season-shared-data.service';
import { TenantService } from 'src/app/services/tenant.service';
import { CostService } from 'src/app/services/cost.service';
import { AnalysisManagementService } from 'src/app/services/analysis-management.service';
import { CostUnitOfMeasureModel } from 'src/app/models/season-models/cost-unit-of-measure-model';
import { FieldMapCostModel } from 'src/app/models/season-models/field-map-cost-model';
import {SeasonFieldBaseDto} from "../../dto/season-dto/season-field-base-dto";
import {SeasonFieldBase} from "../../dto/season-dto/season-field-base";
import {truncateDecimals} from "../../Custom-Directives-Pipes/truncate-decimals.pipe";

@Component({
    selector: 'app-season-field-input',
    templateUrl: './season-field-input.component.html',
    styleUrls: ['./season-field-input.component.css'],
    standalone: false
})
export class SeasonFieldInputComponent implements OnInit, OnChanges {

  seasonInputForm: FormGroup;

  @Input() index: number = -1;
  @Input() inputData: SeasonFieldsModel = null;
  @Input() isInAnotherActiveSeason: boolean = false; //disable if not in season
  @Input() fieldInfo: any = null; //disable if not in season
  @Input() farmIndex: number = -1;
  @Output() formDataChange = new EventEmitter<any>();
  @Input() sharedExtraDetailData: any = null;
  @Input() isViewedFromSeasonAdmin: boolean = false;
  @Input() fieldTypeName: string = '';
  @Input() panelTab: 'field' | 'crop' | 'cost' | null = null;
  @Input() compactMode: boolean = false;

  /**
   * The field's other crop definitions, so the combined cultivar size can be
   * checked before a request is made. Optional - when not supplied the
   * client-side pre-check is skipped and the API 400 is relied on instead.
   */
  @Input() siblingDefinitions: any[] = [];

  /**
   * A cultivar size rejection returned by the API, pushed down by the parent so
   * it renders in the same place as the client-side message.
   */
  @Input() serverCultivarSizeError: string = null;

  sharedDetailData: any = null;

  seasonId: number = 0;
  fieldId: number = 0;
  detailId: number = 0;
  fieldTypeId: number = 0;
  tenantId: number = 0;
  farmId: number = 0;

  isGrainAndFeed: boolean = false;
  isVegetables: boolean = false;
  isFruit: boolean = false;
  isOrchardVineyard: boolean = false;
  isIrrigation: boolean = false;
  isHarvested: boolean = false;
  allowNotifications: boolean = false;
  hide: boolean = false;
  isFormPopulating: boolean = true;
  isInputVisible: boolean = true;
  isHidden: boolean = false;

  protected readonly dayjs = dayjs;
  cropFilterCtrl: FormControl = new FormControl();

  placeholder: string = '-';
  dateStringFormatting = 'YYYY-MM-DD';
  fieldSize: string = null;
  fieldType: string = null;

  get currentFieldTypeName(): string {
    const fieldTypeId = this.seasonInputForm?.get('fieldType')?.value;
    const fieldType = this.types.find(t => t.id === fieldTypeId);
    return fieldType?.description || this.fieldTypeName || '';
  }

  farms: SeasonFarmsModel = null;
  fields: SeasonFieldsModel[] = [];
  seasonInputFormObj: any = null;
  types: SeasonTypeModel[] = [];
  crops: SeasonCropModel[] = [];
  filteredCropsList: SeasonCropModel[] = [];
  irrigationType: SeasonIrrigationTypeModel[] = [];
  tillage: SeasonTillageModel[] = [];
  podEffectiveness: SeasonPodEffectivenessModel[] = [];

  // Cost section properties
  vrtMapTypes: any[] = [];
  asAppliedMapTypes: any[] = [];
  unitsOfMeasure: CostUnitOfMeasureModel[] = [];
  fixedCostValue: number = 0;
  isLoadingCosts: boolean = false;
  private costDebounceTimer: any = null;
  harvestResidues: SeasonHarvestResiduesModel[] = [];
  plantAction: SeasonPlantActionModel[] = [];
  fertilizerPlacement: SeasonFertilizerPlacementModel[] = [];
  plantFertilizerType: SeasonPlantFertilizerTypeModel[] = [];
  plantSpread: SeasonFieldPlantModel[] = [];
  topDressingMethod: SeasonTopDressingMethodModel[] = [];
  typeOfFertilizerBob: SeasonTypeOfFertilizerBobModel[] = [];
  fertilizerType: SeasonFertilizerTypeModel[] = [];
  fertilizerPlacementWithPlanting: SeasonFertilizerPlacementWithPlantingModel[] = [];
  methodOfTopDressing: SeasonMethodOfTopDressingModel[] = [];
  typeOfTopDressingFertilizer: SeasonTypeOfTopDressingFertilizer[] = [];
  waterQualityEcId: SeasonWaterQualityEcModel[] = [];
  seasonStatus: SeasonsStatusModel[] = [];
  seasonPlantSpread: SeasonFieldPlantSpreadModel[] = [];

  constructor(
    public nav: NavBarComponent,
    private seasonManagerService: SeasonManagerService,
    private seasonSharedDataService: SeasonSharedDataService,
    public endSeasonDialog: MatDialog,
    public matDialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private tenantService: TenantService,
    private costService: CostService,
    private analysisManagementService: AnalysisManagementService,
  ) {
    this.seasonInputForm = new FormGroup({
      //BASE DETAILS
      // fieldId: new FormControl(null),
      detailsId: new FormControl(null),
      fieldType: new FormControl(null),
      plantDate: new FormControl(null),
      currentCrop: new FormControl(null),
      cultivar: new FormControl(null),
      cultivarSize: new FormControl(null, [
        Validators.min(0),
        Validators.pattern(/^\d+(\.\d{1,2})?$/)
      ]),
      notes: new FormControl(null, [Validators.maxLength(1000)]),
      yieldAverage: new FormControl(null),
      yieldGoal: new FormControl(null),
      expectedWaterAmount: new FormControl(null),
      irrigationType: new FormControl(null),
      isIrrigation: new FormControl(false),
      isHarvested: new FormControl(false),
      allowNotifications: new FormControl(false),

      //EXTRA DETAILS
      tillage: new FormControl(null),
      harvestResidues: new FormControl(null),
      plantAction: new FormControl(null),
      previousCrop: new FormControl(null),
      bearing: new FormControl(null),
      podEffectiveness: new FormControl(null),
      trackWidth: new FormControl(null),
      fertilizerPlacement: new FormControl(null),
      plantFertilizerType: new FormControl(null),
      topDressingMethod: new FormControl(null),
      typeOfFertilizerBobOne: new FormControl(null),
      typeOfFertilizerBobTwo: new FormControl(null),
      plantSpread: new FormControl(null),
      plantDensity: new FormControl(null),
      fertilizerPlacementWithPlanting: new FormControl(null),
      fertilizerType: new FormControl(null),
      methodOfTopDressing: new FormControl(null),
      typeOfTopDressingFertilizer: new FormControl(null),
      waterQualityEc: new FormControl(null),
      // cropCode: new FormControl(null),
      plantId: new FormControl(null),
      growthPower: new FormControl(null),
      fieldName: new FormControl(null),
      plantYear: new FormControl(null),
      tHaLimeApplied: new FormControl(null),
      timeLimeApplied: new FormControl(null),

      // NEW FIELDS (PG-165)
      fullBloomDate: new FormControl(null),
      rowSpacing: new FormControl(null),
      plantSpacing: new FormControl(null),
      replantDate: new FormControl(null),
      budBreakDate: new FormControl(null),
      buddingDate: new FormControl(null),
      rootstock: new FormControl(null),
      plantsPerHectare: new FormControl(null),
      risingDate: new FormControl(null),
    });

    // Emit form state changes whenever necessary
    this.seasonInputForm.valueChanges.subscribe(value => {

      let fieldDetails: SeasonFieldBaseDto = {
        id: this.inputData?.id ?? null,
        fieldId: this.inputData?.fieldId ?? null,
        fieldTypeId: value.fieldType,
        fieldName: value.fieldName,
        allowNotifications: value.allowNotifications,
        plantDate: value?.plantDate ? String(dayjs(value?.plantDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
        currentCropId: value.currentCrop,
        cultivar: value.cultivar,
        cultivarSize: value.cultivarSize != null && value.cultivarSize !== '' ? Number(value.cultivarSize) : null,
        notes: value.notes != null && value.notes !== '' ? value.notes : null,
        isHarvested: value.isHarvested,
        yieldAverage: value.yieldAverage != null && value.yieldAverage !== '' ? Number(value.yieldAverage) : null,
        yieldGoal: value.yieldGoal != null && value.yieldGoal !== '' ? Number(value.yieldGoal) : null,
        isIrrigation: value.isIrrigation,
        expectedWaterAmount: value.expectedWaterAmount != null && value.expectedWaterAmount !== '' ? Number(value.expectedWaterAmount) : null,
        irrigationTypeId: value.irrigationType,
        grainFeed: {
          id: this.sharedExtraDetailData?.grainFeed?.id ?? null,
          previousCropId: value.fieldType === 1 ? value.previousCrop : null,
          tillageId: value.fieldType === 1 ? value.tillage : null,
          bearing: value.fieldType === 1 && value.bearing != null && value.bearing !== '' ? Number(value.bearing) : null,
          podEffectivenessId: value.fieldType === 1 ? value.podEffectiveness : null,
          harvestResiduesId: value.fieldType === 1 ? value.harvestResidues : null,
          plantId: value.fieldType === 1 ? value.plantSpread : null,
          plantActionId: value.fieldType === 1 ? value.plantAction : null,
          trackWidth: value.fieldType === 1 ? value.trackWidth : null,
          fertilizerPlacementId: value.fieldType === 1 ? value.fertilizerPlacement : null,
          plantFertilizerTypeId: value.fieldType === 1 ? value.plantFertilizerType : null,
          topDressingMethodId: value.fieldType === 1 ? value.topDressingMethod : null,
          typeOfFertilizerBob1Id: value.fieldType === 1 ? value.typeOfFertilizerBobOne : null,
          typeOfFertilizerBob2Id: value.fieldType === 1 ? value.typeOfFertilizerBobTwo : null
        },

      
        vegetables: {
          id: this.sharedExtraDetailData?.vegetables?.id ?? null,
          fertilizerTypeId: value.fieldType === 2 ? value.fertilizerType : null,
          previousCropId: value.fieldType === 2 ? value.previousCrop : null,
          tillageId: value.fieldType === 2 ? value.tillage : null,
          harvestResiduesId: value.fieldType === 2 ? value.harvestResidues : null,
          plantActionId: value.fieldType === 2 ? value.plantAction : null,
          plantDensity: value.fieldType === 2 && value.plantDensity != null && value.plantDensity !== '' ? Number(value.plantDensity) : null,
          fertilizerPlacementWithPlantingId: value.fieldType === 2 ? value.fertilizerPlacementWithPlanting : null,
          methodOfTopDressingId: value.fieldType === 2 ? value.methodOfTopDressing : null,
          typeOfTopDressingFertilizerId: value.fieldType === 2 ? value.typeOfTopDressingFertilizer : null,
          waterQualityEcId: value.fieldType === 2 ? value.waterQualityEc : null,
          timeLimeApplied: value.fieldType === 2 && value?.timeLimeApplied ? String(dayjs(value?.timeLimeApplied).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          thaLimeApplied: value.fieldType === 2 && value.tHaLimeApplied != null && value.tHaLimeApplied !== '' ? Number(value.tHaLimeApplied) : null,
          fullBloomDate: value.fieldType === 2 && value.fullBloomDate ? String(dayjs(value.fullBloomDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          rowSpacing: value.fieldType === 2 ? value.rowSpacing : null,
          plantSpacing: value.fieldType === 2 ? value.plantSpacing : null,
          replantDate: value.fieldType === 2 && value.replantDate ? String(dayjs(value.replantDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          risingDate: value.fieldType === 2 && value.risingDate ? String(dayjs(value.risingDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          plantsPerHectare: value.fieldType === 2 ? value.plantsPerHectare : null
        },
        vineyard: {
          id: this.sharedExtraDetailData?.vineyard?.id ?? null,
          // cropId: value.fieldType === 3 ? value.cropCode : null,
          growthPower: value.fieldType === 3 && value.growthPower != null && value.growthPower !== '' ? Number(value.growthPower) : null, // VIGOR (growth power changed to vigor on UI)
          fertilizerTypeId: value.fieldType === 3 ? value.fertilizerType : null,
          plantYear: value.fieldType === 3 ? value.plantYear : null,
          fullBloomDate: value.fieldType === 3 && value.fullBloomDate ? String(dayjs(value.fullBloomDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          rowSpacing: value.fieldType === 3 ? value.rowSpacing : null,
          plantSpacing: value.fieldType === 3 ? value.plantSpacing : null,
          replantDate: value.fieldType === 3 && value.replantDate ? String(dayjs(value.replantDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          budBreakDate: value.fieldType === 3 && value.budBreakDate ? String(dayjs(value.budBreakDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          buddingDate: value.fieldType === 3 && value.buddingDate ? String(dayjs(value.buddingDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          rootstock: value.fieldType === 3 ? value.rootstock : null
        },
        fruit: {
          id: this.sharedExtraDetailData?.fruit?.id ?? null,
          // cropId: value.fieldType === 4 ? value.s : null,
          growthPower: value.fieldType === 4 && value.growthPower != null && value.growthPower !== '' ? Number(value.growthPower) : null, // VIGOR (growth power changed to vigor on UI)
          fertilizerTypeId: value.fieldType === 4 ? value.fertilizerType : null,
          plantYear: value.fieldType === 4 ? value.plantYear : null,
          fullBloomDate: value.fieldType === 4 && value.fullBloomDate ? String(dayjs(value.fullBloomDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          rowSpacing: value.fieldType === 4 ? value.rowSpacing : null,
          plantSpacing: value.fieldType === 4 ? value.plantSpacing : null,
          replantDate: value.fieldType === 4 && value.replantDate ? String(dayjs(value.replantDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          budBreakDate: value.fieldType === 4 && value.budBreakDate ? String(dayjs(value.budBreakDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          buddingDate: value.fieldType === 4 && value.buddingDate ? String(dayjs(value.buddingDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
          rootstock: value.fieldType === 4 ? value.rootstock : null,
          plantsPerHectare: value.fieldType === 4 ? value.plantsPerHectare : null
        }
      };
      this.checkCultivarSizeAgainstField(value.cultivarSize);

      this.formDataChange.emit({ value: fieldDetails, isFormPopulating: this.isFormPopulating, name: this.seasonInputForm });
    });

    this.seasonSharedDataService.allowBulkNotificationData$.subscribe((data: any) => {
      if (data !== null) {
        this.setBulkAllowNotifications(data);
      }
    })
  }


  ngOnInit(): void {

    this.setMetaData();

    this.cropFilterCtrl.valueChanges.subscribe({
      next: (res) => {
        this.filteredCropsList = [...this.crops.filter(c => c.description.toLowerCase().includes(res.toLowerCase()))];
      }
    })

    this.tenantService.currenttenantId.subscribe(tenantId => {
      if (tenantId) {
        this.tenantId = Number(tenantId);
      } else if (!tenantId && sessionStorage.getItem("selectedTenant") !== null) {
        this.tenantId = Number(sessionStorage.getItem("selectedTenant"));
      }
    });

    this.sharedDetailData = this.seasonSharedDataService.getSeasonDetailBaseData();
    this.populateExistingFormData();
    this.disableFormControls();
    this.isHidden = this.seasonSharedDataService.getIsHiddenData();
    this.loadUnitsOfMeasure();

    this.seasonSharedDataService.seasonIdData$.subscribe(id => {
      if (id && id > 0 && this.seasonId !== id) {
        this.seasonId = id;
        if (this.inputData?.fieldId) {
          this.loadCostData();
        }
      }
    });

    this.seasonSharedDataService.saveCostsTrigger$.subscribe(trigger => {
      if (trigger && !this.isLoadingCosts && (this.inputData?.detailsId || this.inputData?.id)) {
        this.saveCosts();
      }
    });

    this.loadCostData();
  }

  /**
   * Flags the cultivar size control when this definition's value, combined with
   * the field's other definitions, would exceed the field's total size.
   *
   * Skipped when sibling definitions were not supplied or the field has no
   * recorded size - in those cases the API's own check is the safety net.
   * fieldSize is a string on SeasonFieldsModel, hence the parseFloat.
   */
  private checkCultivarSizeAgainstField(currentValue: any): void {
    const control = this.seasonInputForm?.controls?.cultivarSize;
    if (!control) return;

    // Only ever add or remove our own key, so the pattern/min errors survive.
    const clearOwnError = () => {
      const errors = { ...(control.errors || {}) };
      if (errors['cultivarSizeSum']) {
        delete errors['cultivarSizeSum'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    };

    const fieldSize = parseFloat(this.inputData?.fieldSize as any);
    const value = Number(currentValue);

    if (!Number.isFinite(fieldSize) || fieldSize <= 0 || !Number.isFinite(value)) {
      clearOwnError();
      return;
    }

    const currentId = this.inputData?.id;
    const othersTotal = (this.siblingDefinitions || [])
      .filter(d => d && d.id !== currentId)
      .reduce((sum, d) => {
        const s = Number(d.cultivarSize);
        return sum + (Number.isFinite(s) ? s : 0);
      }, 0);

    const total = othersTotal + value;

    if (total > fieldSize) {
      control.setErrors({
        ...(control.errors || {}),
        cultivarSizeSum:
          `Combined cultivar size ${truncateDecimals(total, 2)} ha exceeds field size of ${truncateDecimals(fieldSize, 2)} ha`
      });
    } else {
      clearOwnError();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // A rejection from the API is applied to the same control and error key as
    // the client-side check, so both render through one mat-error. mat-error
    // only shows for an invalid control, so the message must live on the control
    // rather than being displayed on its own.
    if (changes['serverCultivarSizeError']) {
      const control = this.seasonInputForm?.controls?.cultivarSize;
      if (control) {
        const errors = { ...(control.errors || {}) };
        if (this.serverCultivarSizeError) {
          errors['cultivarSizeSum'] = this.serverCultivarSizeError;
          control.setErrors(errors);
          control.markAsTouched();
        } else if (errors['cultivarSizeSum']) {
          delete errors['cultivarSizeSum'];
          control.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }

    const inputDataChanged = changes['inputData'] && !changes['inputData'].firstChange;
    const extraDataChanged = changes['sharedExtraDetailData'] && !changes['sharedExtraDetailData'].firstChange;
    
    if (inputDataChanged || extraDataChanged) {
      const oldFieldId = changes['inputData']?.previousValue?.fieldId;
      const newFieldId = changes['inputData']?.currentValue?.fieldId;
      
      const fieldActuallyChanged = oldFieldId !== newFieldId;
      
      if (fieldActuallyChanged) {
        this.isFormPopulating = true;
        this.resetFormFields();
        this.populateExistingFormData();
        this.loadCostData();
      } else if (inputDataChanged && !this.isFormPopulating) {
        // Same field, new data reference — only repopulate if the definition ID changed
        // (i.e. a real API refresh, not a parent re-emitting form data back)
        const oldId = changes['inputData'].previousValue?.id;
        const newId = changes['inputData'].currentValue?.id;
        if (oldId !== newId) {
          this.isFormPopulating = true;
          this.populateExistingFormData();
          this.loadCostData();
        }
      }

      // Always repopulate when extra detail data changes (e.g. tab switch async fetch completes)
      if (extraDataChanged && !fieldActuallyChanged) {
        this.isFormPopulating = true;
        this.populateExistingFormData();
      }
    }
  }

  resetFormFields() {
    this.seasonInputForm.reset({}, { emitEvent: false });
    this.isGrainAndFeed = false;
    this.isVegetables = false;
    this.isFruit = false;
    this.isOrchardVineyard = false;
    this.fieldSize = null;
  }

  fieldNameUpdate(fieldName: string) {
    this.seasonSharedDataService.updateFieldName(fieldName);
  }



  disableFormControls() {
    const currentUrl = this.router.url;
    
    if (currentUrl.includes('season-admin') || currentUrl.includes('field-details')) {
      this.seasonInputForm.enable();
      return;
    }
    
    if (currentUrl.includes('sample-batch-update')) {
      this.isInputVisible = false;
    }

    if (this.isInAnotherActiveSeason == false) {
      this.seasonInputForm.disable();
      this.seasonInputForm.get('fieldName')?.enable();
      this.seasonInputForm.get('allowNotifications')?.enable();
    } else {
      this.seasonInputForm.enable();
    }
  }
  populateExistingFormData() {
    this.isFormPopulating = true;
    this.seasonInputForm.reset({}, { emitEvent: false });
    
    if (this.inputData) {
      //ADDED HIDDEN INPUT FIELDS TO ACCESS fieldId + detailsId in other components
      // if (this.inputData.fieldId) {
      //   this.seasonInputForm.controls.fieldId.setValue(this.inputData.fieldId);
      // }
      //
      // if (this.inputData.id) {
      //   this.seasonInputForm.controls.detailsId.setValue(this.inputData.id);
      // }

      this.seasonInputForm.controls.fieldName.setValue(this.inputData.fieldName);

      if (this.inputData.fieldSize) {
        // Truncated, not rounded: this is the number shown beside the cultivar
        // size input and validated against, so it must never read higher than the
        // real field size.
        this.fieldSize = truncateDecimals(this.inputData.fieldSize, 2);
      }

      ////////////////////////////////////////////////////////////////////////

      //////////////////////////////////////////////////////
      ///////////////  BASE DATA  //////////////////////////
      //////////////////////////////////////////////////////

      if (this.inputData.fieldType) {
        for (let type of this.types) {
          if (this.inputData.fieldType === type.id) {
            this.seasonInputForm.controls.fieldType.setValue(type.id, { emitEvent: false });
            break;
          }
        }


        if (this.seasonInputForm.controls.fieldType.value !== null) {
          this.toggleType();
        }
      }


      if (this.inputData.currentCrop) {
        for (let crop of this.crops) {
          if (this.inputData.currentCrop === crop.id) {
            this.seasonInputForm.controls.currentCrop.setValue(crop.id, { emitEvent: false });
            break;
          }
        }
      }


      if (this.inputData.irrigationType) {
        for (let irgType of this.irrigationType) {
          if (this.inputData.irrigationType === irgType.id) {
            this.seasonInputForm.controls.irrigationType.setValue(irgType.id, { emitEvent: false });
            break;
          }
        }
      }

      if (this.inputData.plantDate) {
        this.seasonInputForm.controls.plantDate.setValue(this.inputData.plantDate);
      }

      if (this.inputData.yieldAverage) {
        this.seasonInputForm.controls.yieldAverage.setValue(this.inputData.yieldAverage);
      }

      if (this.inputData.yieldGoal) {
        this.seasonInputForm.controls.yieldGoal.setValue(this.inputData.yieldGoal);
      }


      if (this.inputData.cultivar) {
        this.seasonInputForm.controls.cultivar.setValue(this.inputData.cultivar);
      }


      // Explicit null check so a legitimate 0 is still populated
      if (this.inputData.cultivarSize != null) {
        this.seasonInputForm.controls.cultivarSize.setValue(this.inputData.cultivarSize);
      }


      if (this.inputData.notes) {
        this.seasonInputForm.controls.notes.setValue(this.inputData.notes);
      }


      if (this.inputData.isIrrigation) {
        this.seasonInputForm.controls.isIrrigation.setValue(this.inputData.isIrrigation);
      }


      if (this.inputData.allowNotifications) {
        this.seasonInputForm.controls.allowNotifications.setValue(this.inputData.allowNotifications);
      }


      if (this.inputData.isHarvested) {
        this.seasonInputForm.controls.isHarvested.setValue(this.inputData.isHarvested);
      }


      if (this.inputData.expectedWaterAmount) {
        this.seasonInputForm.controls.expectedWaterAmount.setValue(this.inputData.expectedWaterAmount);
      }

    }

    if (this.sharedExtraDetailData !== null) {

      //////////////////////////////////////////////////////
      ///////////////  GRAIN FEED //////////////////////////
      //////////////////////////////////////////////////////
      if (this.inputData?.fieldType === 1) {
        if (this.sharedExtraDetailData.grainFeed?.podEffectivenessId) {
          for (let podEffect of this.podEffectiveness) {
            if (this.sharedExtraDetailData.grainFeed.podEffectivenessId === podEffect.id) {
              this.seasonInputForm.controls.podEffectiveness.setValue(podEffect.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.grainFeed?.trackWidth) {
          this.seasonInputForm.controls.trackWidth.setValue(this.sharedExtraDetailData.grainFeed.trackWidth);
        }

        if (this.sharedExtraDetailData.grainFeed?.typeOfFertilizerBob1Id) {
          for (let typeFertBob of this.typeOfFertilizerBob) {
            if (this.sharedExtraDetailData.grainFeed.typeOfFertilizerBob1Id === typeFertBob.id) {
              this.seasonInputForm.controls.typeOfFertilizerBobOne.setValue(typeFertBob.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.grainFeed?.previousCropId) {
          for (let crop of this.crops) {
            if (this.sharedExtraDetailData.grainFeed.previousCropId === crop.id) {
              this.seasonInputForm.controls.previousCrop.setValue(crop.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.grainFeed?.harvestResiduesId) {
          for (let harvestResidue of this.harvestResidues) {
            if (this.sharedExtraDetailData.grainFeed.harvestResiduesId === harvestResidue.id) {
              this.seasonInputForm.controls.harvestResidues.setValue(harvestResidue.id);
              break;
            }
          }
        }

        if(this.sharedExtraDetailData?.grainFeed?.fertilizerPlacementId) {
          for (let fertilizerPlace of this.fertilizerPlacement) {
            if (this.sharedExtraDetailData?.grainFeed?.fertilizerPlacementId === fertilizerPlace.id) {
              this.seasonInputForm.controls.fertilizerPlacement.setValue(fertilizerPlace.id);
              break;
            }
          }
        }

        if(this.sharedExtraDetailData?.grainFeed?.typeOfFertilizerBob2Id) {
          for (let typeFertBob of this.typeOfFertilizerBob) {
            if (this.sharedExtraDetailData?.grainFeed?.typeOfFertilizerBob2Id === typeFertBob.id) {
              this.seasonInputForm.controls.typeOfFertilizerBobTwo.setValue(typeFertBob.id);
              break;
            }
          }
        }

        if(this.sharedExtraDetailData?.grainFeed?.plantActionId) {
          for (let plant of this.plantAction) {
            if (this.sharedExtraDetailData?.grainFeed?.plantActionId === plant.id) {
              this.seasonInputForm.controls.plantAction.setValue(plant.id);
              break;
            }
          }
        }

        if(this.sharedExtraDetailData.grainFeed?.topDressingMethodId) {
          for (let topDressMethod of this.topDressingMethod) {
            if (this.sharedExtraDetailData?.grainFeed?.topDressingMethodId === topDressMethod.id) {
              this.seasonInputForm.controls.topDressingMethod.setValue(topDressMethod.id);
              break;
            }
          }
        }


        if(this.sharedExtraDetailData?.grainFeed?.tillageId) {
          for (let till of this.tillage) {
            if (this.sharedExtraDetailData?.grainFeed?.tillageId === till.id) {
              this.seasonInputForm.controls.tillage.setValue(till.id);
              break;
            }
          }
        }

        if(this.sharedExtraDetailData?.grainFeed?.plantFertilizerTypeId) {
          for (let plantFertType of this.plantFertilizerType) {
            if (this.sharedExtraDetailData?.grainFeed?.plantFertilizerTypeId === plantFertType.id) {
              this.seasonInputForm.controls.plantFertilizerType.setValue(plantFertType.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.grainFeed?.bearing) {
          this.seasonInputForm.controls.bearing.setValue(this.sharedExtraDetailData.grainFeed.bearing);
        }

        if (this.sharedExtraDetailData.grainFeed?.selectedTopDressingMethodId) {
          for (let topDressMethod of this.topDressingMethod) {
            if (this.sharedExtraDetailData.grainFeed.selectedTopDressingMethodId === topDressMethod.id) {
              this.seasonInputForm.controls.topDressingMethod.setValue(topDressMethod.id);
              break;
            }
          }
        }


        if (this.sharedExtraDetailData.grainFeed?.plantId) {
          for (let plant of this.plantSpread) {
            if (this.sharedExtraDetailData.grainFeed.plantId === plant.id) {
              this.seasonInputForm.controls.plantSpread.setValue(plant.id);
              break;
            }
          }
        }
      }

      //////////////////////////////////////////////////////
      ///////////////  VEGETABLE //////////////////////////
      //////////////////////////////////////////////////////
      if (this.inputData?.fieldType === 2) {

        if (this.sharedExtraDetailData.vegetables?.plantActionId) {
          for (let plant of this.plantAction) {
            if (this.sharedExtraDetailData.vegetables.plantActionId === plant.id) {
              this.seasonInputForm.controls.plantAction.setValue(plant.id);
              break;
            }
          }
        }


        if (this.sharedExtraDetailData.vegetables?.methodOfTopDressingId) {
          for (let methodOfTopDress of this.methodOfTopDressing) {
            if (this.sharedExtraDetailData.vegetables.methodOfTopDressingId === methodOfTopDress.id) {
              this.seasonInputForm.controls.methodOfTopDressing.setValue(methodOfTopDress.id);
              break;
            }
          }
        }


        if (this.sharedExtraDetailData.vegetables?.previousCropId) {
          for (let crop of this.crops) {
            if (this.sharedExtraDetailData.vegetables.previousCropId === crop.id) {
              this.seasonInputForm.controls.previousCrop.setValue(crop.id);
              break;
            }
          }
        }


        if (this.sharedExtraDetailData.vegetables?.typeOfTopDressingFertilizerId) {
          for (let typeOfTopDressFert of this.typeOfTopDressingFertilizer) {
            if (this.sharedExtraDetailData.vegetables.typeOfTopDressingFertilizerId === typeOfTopDressFert.id) {
              this.seasonInputForm.controls.typeOfTopDressingFertilizer.setValue(typeOfTopDressFert.id);
              break;
            }
          }
        }


        if (this.sharedExtraDetailData.vegetables?.tillageId) {
          for (let till of this.tillage) {
            if (this.sharedExtraDetailData.vegetables.tillageId === till.id) {
              this.seasonInputForm.controls.tillage.setValue(till.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.vegetables?.fertilizerPlacementWithPlantingId) {
          for (let fertilizerPlaceWith of this.fertilizerPlacementWithPlanting) {
            if (this.sharedExtraDetailData.vegetables.fertilizerPlacementWithPlantingId === fertilizerPlaceWith.id) {
              this.seasonInputForm.controls.fertilizerPlacementWithPlanting.setValue(fertilizerPlaceWith.id);
              break;
            }
          }

        }


        if (this.sharedExtraDetailData.vegetables?.waterQualityEcId) {
          for (let waterQuality of this.waterQualityEcId) {
            if (this.sharedExtraDetailData.vegetables.waterQualityEcId === waterQuality.id) {
              this.seasonInputForm.controls.waterQualityEc.setValue(waterQuality.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.vegetables?.harvestResiduesId) {
          for (let harvestResidue of this.harvestResidues) {
            if (this.sharedExtraDetailData.vegetables.harvestResiduesId === harvestResidue.id) {
              this.seasonInputForm.controls.harvestResidues.setValue(harvestResidue.id);
              break;
            }
          }
        }


        if (this.sharedExtraDetailData.vegetables?.fertilizerTypeId) {
          for (let fertType of this.fertilizerType) {
            if (this.sharedExtraDetailData.vegetables.fertilizerTypeId === fertType.id) {
              this.seasonInputForm.controls.fertilizerType.setValue(fertType.id);
              break;
            }
          }
        }


        if (this.sharedExtraDetailData.vegetables?.tHaLimeApplied) {
          this.seasonInputForm.controls.tHaLimeApplied.setValue(this.sharedExtraDetailData.vegetables.tHaLimeApplied);
        }

        if (this.sharedExtraDetailData.vegetables?.plantDensity) {
          this.seasonInputForm.controls.plantDensity.setValue(this.sharedExtraDetailData.vegetables.plantDensity);
        }

        if (this.sharedExtraDetailData.vegetables?.timeLimeApplied) {
          this.seasonInputForm.controls.timeLimeApplied.setValue(this.sharedExtraDetailData.vegetables.timeLimeApplied);
        }

        if (this.sharedExtraDetailData.vegetables?.fullBloomDate) {
          this.seasonInputForm.controls.fullBloomDate.setValue(this.sharedExtraDetailData.vegetables.fullBloomDate);
        }
        if (this.sharedExtraDetailData.vegetables?.rowSpacing) {
          this.seasonInputForm.controls.rowSpacing.setValue(this.sharedExtraDetailData.vegetables.rowSpacing);
        }
        if (this.sharedExtraDetailData.vegetables?.plantSpacing) {
          this.seasonInputForm.controls.plantSpacing.setValue(this.sharedExtraDetailData.vegetables.plantSpacing);
        }
        if (this.sharedExtraDetailData.vegetables?.replantDate) {
          this.seasonInputForm.controls.replantDate.setValue(this.sharedExtraDetailData.vegetables.replantDate);
        }
        if (this.sharedExtraDetailData.vegetables?.risingDate) {
          this.seasonInputForm.controls.risingDate.setValue(this.sharedExtraDetailData.vegetables.risingDate);
        }
        if (this.sharedExtraDetailData.vegetables?.plantsPerHectare) {
          this.seasonInputForm.controls.plantsPerHectare.setValue(this.sharedExtraDetailData.vegetables.plantsPerHectare);
        }

      }

      //////////////////////////////////////////////////////
      ///////////////  VINYARD //////////////////////////
      //////////////////////////////////////////////////////

      if (this.inputData?.fieldType === 3) {
        if (this.sharedExtraDetailData.vineyard?.fertilizerTypeId) {
          for (let fertType of this.fertilizerType) {
            if (this.sharedExtraDetailData.vineyard.fertilizerTypeId === fertType.id) {
              this.seasonInputForm.controls.fertilizerType.setValue(fertType.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.vineyard?.plantYear) {
          this.seasonInputForm.controls.plantYear.setValue(this.sharedExtraDetailData.vineyard.plantYear);
        }

        if (this.sharedExtraDetailData.vineyard?.growthPower) {
          this.seasonInputForm.controls.growthPower.setValue(this.sharedExtraDetailData.vineyard.growthPower);
        }

        if (this.sharedExtraDetailData.vineyard?.fullBloomDate) {
          this.seasonInputForm.controls.fullBloomDate.setValue(this.sharedExtraDetailData.vineyard.fullBloomDate);
        }
        if (this.sharedExtraDetailData.vineyard?.rowSpacing) {
          this.seasonInputForm.controls.rowSpacing.setValue(this.sharedExtraDetailData.vineyard.rowSpacing);
        }
        if (this.sharedExtraDetailData.vineyard?.plantSpacing) {
          this.seasonInputForm.controls.plantSpacing.setValue(this.sharedExtraDetailData.vineyard.plantSpacing);
        }
        if (this.sharedExtraDetailData.vineyard?.replantDate) {
          this.seasonInputForm.controls.replantDate.setValue(this.sharedExtraDetailData.vineyard.replantDate);
        }
        if (this.sharedExtraDetailData.vineyard?.budBreakDate) {
          this.seasonInputForm.controls.budBreakDate.setValue(this.sharedExtraDetailData.vineyard.budBreakDate);
        }
        if (this.sharedExtraDetailData.vineyard?.buddingDate) {
          this.seasonInputForm.controls.buddingDate.setValue(this.sharedExtraDetailData.vineyard.buddingDate);
        }
        if (this.sharedExtraDetailData.vineyard?.rootstock) {
          this.seasonInputForm.controls.rootstock.setValue(this.sharedExtraDetailData.vineyard.rootstock);
        }
      }

      //////////////////////////////////////////////////////
      ///////////////////  FRUIT //////////////////////////
      /////////////////////////////////////////////////////

      if (this.inputData?.fieldType === 4) {
        if (this.sharedExtraDetailData.fruit?.fertilizerTypeId) {
          for (let fertType of this.fertilizerType) {
            if (this.sharedExtraDetailData.fruit.fertilizerTypeId === fertType.id) {
              this.seasonInputForm.controls.fertilizerType.setValue(fertType.id);
              break;
            }
          }
        }

        if (this.sharedExtraDetailData.fruit?.plantYear) {
          this.seasonInputForm.controls.plantYear.setValue(this.sharedExtraDetailData.fruit.plantYear);
        }

        if (this.sharedExtraDetailData.fruit?.growthPower) {
          this.seasonInputForm.controls.growthPower.setValue(this.sharedExtraDetailData.fruit.growthPower);
        }

        if (this.sharedExtraDetailData.fruit?.fullBloomDate) {
          this.seasonInputForm.controls.fullBloomDate.setValue(this.sharedExtraDetailData.fruit.fullBloomDate);
        }
        if (this.sharedExtraDetailData.fruit?.rowSpacing) {
          this.seasonInputForm.controls.rowSpacing.setValue(this.sharedExtraDetailData.fruit.rowSpacing);
        }
        if (this.sharedExtraDetailData.fruit?.plantSpacing) {
          this.seasonInputForm.controls.plantSpacing.setValue(this.sharedExtraDetailData.fruit.plantSpacing);
        }
        if (this.sharedExtraDetailData.fruit?.replantDate) {
          this.seasonInputForm.controls.replantDate.setValue(this.sharedExtraDetailData.fruit.replantDate);
        }
        if (this.sharedExtraDetailData.fruit?.budBreakDate) {
          this.seasonInputForm.controls.budBreakDate.setValue(this.sharedExtraDetailData.fruit.budBreakDate);
        }
        if (this.sharedExtraDetailData.fruit?.buddingDate) {
          this.seasonInputForm.controls.buddingDate.setValue(this.sharedExtraDetailData.fruit.buddingDate);
        }
        if (this.sharedExtraDetailData.fruit?.rootstock) {
          this.seasonInputForm.controls.rootstock.setValue(this.sharedExtraDetailData.fruit.rootstock);
        }
        if (this.sharedExtraDetailData.fruit?.plantsPerHectare) {
          this.seasonInputForm.controls.plantsPerHectare.setValue(this.sharedExtraDetailData.fruit.plantsPerHectare);
        }
      }
    }
    
    this.isFormPopulating = false;
  }


  toggleType() {

    let type = this.seasonInputForm.get('fieldType').value;

    if (type.id == 1 || this.seasonInputForm.controls.fieldType.value == 1) {
      this.isGrainAndFeed = true;
    } else {
      this.isGrainAndFeed = false;
    }

    if (type.id == 2 || this.seasonInputForm.controls.fieldType.value == 2) {
      this.isVegetables = true;
    } else {
      this.isVegetables = false;
    }

    if (type.id == 3 || this.seasonInputForm.controls.fieldType.value == 3) {
      this.isFruit = true;
    } else {
      this.isFruit = false;
    }

    if (type.id == 4 || this.seasonInputForm.controls.fieldType.value == 4) {
      this.isOrchardVineyard = true;
    } else {
      this.isOrchardVineyard = false;
    }
  }

  onToggleIrrigation(event: MatSlideToggleChange) {
    this.isIrrigation = event.checked;
  }

  onToggleisHarvested(event: MatSlideToggleChange) {
    this.isHarvested = event.checked;
  }

  onToggleAllowNotifications(event: MatSlideToggleChange) {
    this.allowNotifications = event.checked;
    this.seasonSharedDataService.updateAllowNotification(this.allowNotifications);
  }

  setBulkAllowNotifications(data: any) {
    if (data?.farmIndex === this.farmIndex) {
      this.seasonInputForm.controls.allowNotifications.setValue(data.checked);
    }
  }

  setMetaData() {

    this.seasonSharedDataService.typeData$.subscribe(data => {
      this.types = data;
    });

    this.seasonSharedDataService.cropData$.subscribe(data => {
      this.crops = data;
      this.crops.sort((a,b) => {
        const cropA = a.description.toLowerCase();
        const cropB =  b.description.toLowerCase();

        if(cropA < cropB) {
          return -1;
        } else if(cropA > cropB) {
          return 1;
        }

        return 0;
      });
      this.filteredCropsList = [...this.crops];
    });

    this.seasonSharedDataService.irrigationTypeData$.subscribe(data => {
      this.irrigationType = data;
      if (this.types?.length > 0 && this.crops?.length > 0 && this.irrigationType?.length > 0 && this.inputData) {
        this.populateExistingFormData();
      }
    });

    this.seasonSharedDataService.tillageData$.subscribe(data => {
      this.tillage = data;
    });

    this.seasonSharedDataService.podEffectivenessData$.subscribe(data => {
      this.podEffectiveness = data;
    });

    this.seasonSharedDataService.harvestResiduesData$.subscribe(data => {
      this.harvestResidues = data;
    });

    this.seasonSharedDataService.plantActionData$.subscribe(data => {
      this.plantAction = data;
    });

    this.seasonSharedDataService.fertilizerPlacementData$.subscribe(data => {
      this.fertilizerPlacement = data;
    });


    this.seasonSharedDataService.plantFertilizerTypeData$.subscribe(data => {
      this.plantFertilizerType = data;
    });

    this.seasonSharedDataService.fertilizerTypeData$.subscribe(data => {
      this.fertilizerType = data;
    });


    this.seasonSharedDataService.seasonFieldPlantData$.subscribe(data => {
      this.seasonPlantSpread = data;
    });

    this.seasonSharedDataService.topDressingMethodData$.subscribe(data => {
      this.topDressingMethod = data;
    });

    this.seasonSharedDataService.typeOfFertilizerBobData$.subscribe(data => {
      this.typeOfFertilizerBob = data;
    });

    this.seasonSharedDataService.fertilizerPlacementWithPlantingData$.subscribe(data => {
      this.fertilizerPlacementWithPlanting = data;
    });

    this.seasonSharedDataService.methodOfTopDressingData$.subscribe(data => {
      this.methodOfTopDressing = data;
    });

    this.seasonSharedDataService.typeOfTopDressingFertilizerData$.subscribe(data => {
      this.typeOfTopDressingFertilizer = data;
    });

    this.seasonSharedDataService.waterQualityEcData$.subscribe(data => {
      this.waterQualityEcId = data;
    });

    this.seasonSharedDataService.seasonStatusData$.subscribe(data => {
      this.seasonStatus = data;
    });

    this.seasonSharedDataService.plantSpreadData$.subscribe(data => {
      this.plantSpread = data;
    });
  }

  // ==================== COST SECTION METHODS ====================

  loadUnitsOfMeasure(): void {
    this.costService.getUnitsOfMeasure().subscribe(uoms => {
      this.unitsOfMeasure = uoms;
    });
  }

  loadCostData(): void {
    if (!this.inputData?.fieldId) return;

    this.isLoadingCosts = true;
    this.vrtMapTypes = [];
    this.asAppliedMapTypes = [];
    this.fixedCostValue = 0;

    const detailId = this.inputData.detailsId || this.inputData.id;

    if (!detailId) {
      this.isLoadingCosts = false;
      return;
    }

    this.loadInputOptions(detailId);
  }

  /**
   * Public method to force a full reload of form data + cost data.
   * Use when the parent has programmatically changed the inputData and
   * ngOnChanges guards may block the reload (e.g. after addDefinition).
   */
  reloadAllData(): void {
    this.populateExistingFormData();
    this.loadCostData();
  }

  private loadAnalysisAvailability(fieldId: number, detailId: number, seasonStart: string, seasonEnd: string): void {
    this.loadInputOptions(detailId);
  }

  private loadInputOptions(detailId: number): void {
    this.costService.getInputOptions(detailId).subscribe(options => {
      this.vrtMapTypes = (options || [])
        .filter(o => o.sourceType === 'VRT')
        .map(o => ({ type: o.inputName, costValue: 0, unitOfMeasureId: null }));

      this.asAppliedMapTypes = (options || [])
        .filter(o => o.sourceType === 'ASAPPLIED')
        .map(o => ({ type: o.inputName, costValue: 0, unitOfMeasureId: null }));

      this.loadExistingCosts(detailId);
    }, () => {
      this.isLoadingCosts = false;
    });
  }

  loadExistingCosts(detailId: number): void {
    this.costService.getCosts(detailId).subscribe(costs => {
      costs.forEach(cost => {
        if (cost.mapCategory === 'FIXED') {
          this.fixedCostValue = cost.costValue || 0;
        } else if (cost.mapCategory === 'VRT') {
          const match = this.vrtMapTypes.find(v => v.type === cost.mapType);
          if (match) {
            match.costValue = cost.costValue || 0;
            match.unitOfMeasureId = cost.unitOfMeasureId;
          }
        } else if (cost.mapCategory === 'ASAPPLIED') {
          const match = this.asAppliedMapTypes.find(a => a.type === cost.mapType);
          if (match) {
            match.costValue = cost.costValue || 0;
            match.unitOfMeasureId = cost.unitOfMeasureId;
          }
        }
      });
      this.isLoadingCosts = false;
    }, () => {
      this.isLoadingCosts = false;
    });
  }

  onFixedCostBlur(): void {
    const detailId = this.inputData?.detailsId || this.inputData?.id;
    if (!detailId) return;
    this.saveCostDebounced({
      seasonFieldDetailId: detailId,
      mapType: 'FIXED',
      mapCategory: 'FIXED',
      costValue: this.fixedCostValue || 0,
      unitOfMeasureId: null
    });
  }

  onCostBlur(item: any, category: string): void {
    const detailId = this.inputData?.detailsId || this.inputData?.id;
    if (!detailId || !item.unitOfMeasureId) return;
    if (item.costValue != null && (item.costValue < 0 || item.costValue > 1000000)) return;
    this.saveCostDebounced({
      seasonFieldDetailId: detailId,
      mapType: item.type,
      mapCategory: category,
      costValue: item.costValue || 0,
      unitOfMeasureId: item.unitOfMeasureId
    });
  }

  private saveCostDebounced(request: any): void {
    if (this.costDebounceTimer) {
      clearTimeout(this.costDebounceTimer);
    }
    this.costDebounceTimer = setTimeout(() => {
      this.costService.upsertCost(request).subscribe();
    }, 500);
  }

  saveCosts(): void {
    const costs = this.getCostDataForSave();
    if (costs && costs.length > 0) {
      costs.forEach(cost => {
        this.costService.upsertCost(cost).subscribe();
      });
    }
  }

  getCostDataForSave(): any[] {
    const detailId = this.inputData?.detailsId || this.inputData?.id;
    if (!detailId) return null;

    const costs = [];

    // Fixed cost
    costs.push({
      seasonFieldDetailId: detailId,
      mapType: 'FIXED',
      mapCategory: 'FIXED',
      costValue: this.fixedCostValue || 0,
      unitOfMeasureId: null
    });

    // VRT costs
    this.vrtMapTypes.forEach(vrt => {
      if (vrt.unitOfMeasureId) {
        costs.push({
          seasonFieldDetailId: detailId,
          mapType: vrt.type,
          mapCategory: 'VRT',
          costValue: vrt.costValue || 0,
          unitOfMeasureId: vrt.unitOfMeasureId
        });
      }
    });

    // As Applied costs
    this.asAppliedMapTypes.forEach(aa => {
      if (aa.unitOfMeasureId) {
        costs.push({
          seasonFieldDetailId: detailId,
          mapType: aa.type,
          mapCategory: 'ASAPPLIED',
          costValue: aa.costValue || 0,
          unitOfMeasureId: aa.unitOfMeasureId
        });
      }
    });

    return costs;
  }
}

